export const helper = {
    emailRegex:
        '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
    codeSMSRegex: /^[0-9]+$/,
    phoneRegex: '[0-9]{6,20}',
    cnpRegex: '[0-9]{13,13}',
    validatorsAccrossApp: {
        minPassword: 8,
        maxPassword: 50,
        emailMaxLength: 50,
        minStringLength: 2,
        maxStringLength: 60,
        minSmsCodeLength: 1,
        maxSmsCodeLength: 1,
    },
    dialogConfig: {
        colorButtons: {
            standard: '#DD6B55',
            danger: '#b92929',
            warning: '#dd7a24',
            success: '#2ab27b',
            info: '#5bc0de',
            primary: '#0275d8',
            secondary: '#6c757d',
            light: '#f7f7f7',
            dark: '#343a40',
            default: '#007bff',
        },
        icons: {
            success: 'success',
            error: 'error',
            info: 'info',
            warning: 'warning',
        },
        headers: {
            success: 'Succes',
            error: 'Atenție', // "Eroare",
            errorAtentie: 'Atenție',
            successForm: 'Felicitări!',
        },
        generalMessages: {
            error:
                'Ne pare rău, dar am întâmpinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport Tehnic.',
            fileErrorMsg:
                'Ne pare rău, dar fișierul selectat nu a putut fi încărcat. Vă rugăm să reîncercați!',
            pleaseWait: 'Vă rugăm așteptați!',
            fileSuccessfullyUploaded: 'Fișierul dvs. a fost adăugat cu succes!',
        },
        buttonLabels: {
            close: 'Închide',
            save: 'Salvează',
            ok: 'Ok',
            confirm: 'Confirm',
            retry: 'Reîncercă',
        },
        commonTitles: {
            areYouSure: 'Sunteți sigur?',
        },
    },
    swalTextConfig: {
        generalMessages: {
            validate: 'O să validați această cerere! Acțiune ireversibilă!',
            invalidate: 'O să invalidați această cerere! Acțiune ireversibilă!',
            clasare: 'O să clasați această cerere! Acțiune ireversibilă!',
            successs: 'Cererea a fost actualizată cu succes!',
            delete: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            deleteDocument: 'O sa ștergeți acest document! Acțiune ireversibilă!',
            deleteDocumentSuccess: 'Documentul a fost șters cu succes!',
            deleteDocumentCancel:
                'O să anulați validarea acestui document! Acțiune ireversibilă!',
            deleteDocumentCancelSuccess: 'Documentul a fost anulat cu succes!',
            cleanCache:
                'O să curățați cache-ul alocat resurselor incarcate. Cache-ul se va reîncărca cu informații actualizate din DB!',
            cleanCacheSuccess: 'Cache curățat cu succes.',
            confirmReset: 'Confirmati operatiunea de reset incarcare document semnat?'
        },
        validationMessages: {
            cancelButton: 'Anulați',
            confirmButton: 'Confirm!',
        },
        headers: {
            success: 'Succes',
            error: 'Atenție', // "Eroare",
            errorAtentie: 'Atenție',
            successForm: 'Felicitări!',
            deleted: 'Șters!',
        },
        buttonLabels: {
            close: 'Închide',
            save: 'Salvează',
            ok: 'Ok',
            confirm: 'Confirm',
            retry: 'Reîncercă',
        },
        inputPlaceholders: {
            invalidate: 'Completați motivul invalidării.',
            cancel: 'Completați motivul anulării cererii.',
            deleteDocument: 'Completați motivul ștergerii documentului.',
        },
        commonTitles: {
            areYouSure: 'Sunteți sigur?',
        },
    },
};
